import React from "react";
import moment from "moment";
import { includes } from "lodash";

function UpdateItem({
  item,
  onClick,
}) {
  const validUpdates = [
    "ptp_verified",
    "btp_verified",
    "ptp_rejected",
    "btp_rejected",
    "submit_another_trade_doc_rejected",
    "system"
  ]

  if(!includes(validUpdates, item.fca_action)) return <div />;

  function timeAgo() {
    return moment(item.created_at).fromNow();
  }

  function url() {
    const { owner_type, owner_id } = item;
    switch(owner_type) {
      case 'PurchaseOrder':
        return `/purchase_orders/${owner_id}`;
      case 'Invoice':
        return `/invoices/${owner_id}`;
      case 'BusinessTrustpass':
        return `/requirements`;
      case 'PersonalTrustpass':
        return `/requirements`;
      default:
        return null;
    }
  }

  function renderIcon() {
    return item.fca_action === 'submit_another_trade_doc_rejected' ?
      <i className="materialIcon --small -danger"> close </i> :
      <i className="materialIcon --small -success"> done </i>;
  }

  return (
    <section className="cardSection _withColumns _simple --micro">
      {renderIcon()}
      <div className="text _widthAuto">
        <p className="copy --small _noBottomMargin">
          <b className="emphasize">{item.header}</b><br />
          {item.message}
        </p>
        <small className="byline">{timeAgo()}</small>
      </div>
      <button onClick={() => { onClick(url()) }} class="ds-btn --micro -secondary _widthAuto">
        {item.fca_action === "system" ? "Ok" : "Details"}
      </button>
    </section>
  );
}


export default UpdateItem;



// WEBPACK FOOTER //
// ./src/features/notifications/components/UpdateItem.js